import Profile from './Profile'
import ProfilePaymentDetails from './ProfilePaymentDetails'
import ProfileCardDetails from './ProfileCardDetails'
import ProfileTalentDescription from './ProfileTalentDescription'
import ProfileTalentKnownFor from './ProfileTalentKnownFor'
import ProfileTalentCharitiesAndSponsors from './ProfileTalentCharitiesAndSponsors'
import ProfileTalentThemes from './ProfileTalentThemes'
import ProfileTalentLocations from './ProfileTalentLocations'
import ProfileTalentProfileImage from './ProfileTalentProfileImage'
import ProfileGenericProfileImage from './ProfileGenericProfileImage'
import ProfileTalentAvailability from './ProfileTalentAvailability'
import ProfileTalentEndorsementsList from './ProfileTalentEndorsementsList'
import ProfileTalentPackages from './ProfileTalentPackages'
import ProfileTalentIndustries from './ProfileTalentIndustries'
import ProfileSocialSharing from './ProfileSocialSharing'
import ProfileVlastPrivacyPolicy from './ProfileVlastPrivacyPolicy'
import ProfileInterestTags from './ProfileInterestTags'
import ProfileCareerTags from './ProfileCareerTags'

export default {
  Profile,
  ProfilePaymentDetails,
  ProfileCardDetails,
  ProfileTalentDescription,
  ProfileTalentKnownFor,
  ProfileTalentCharitiesAndSponsors,
  ProfileTalentThemes,
  ProfileTalentLocations,
  ProfileTalentProfileImage,
  ProfileGenericProfileImage,
  ProfileTalentAvailability,
  ProfileTalentEndorsementsList,
  ProfileTalentPackages,
  ProfileTalentIndustries,
  ProfileSocialSharing,
  ProfileVlastPrivacyPolicy,
  ProfileInterestTags,
  ProfileCareerTags
}
